import styled from "styled-components";

const PointerSpan = styled.span`
  cursor: pointer;
`;

export default PointerSpan;
